<template>
  <div>
    <p>{{lang.infotext_1}}: <b>{{ selectedLibrary }}</b><br>
      {{ lang.infotext_2 }}: <b>{{ libraryCategory }}</b></p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'InfoElementComponent',
  props:{
    lang: Object
  },
  components: {


  },
  data () {
      return {
        libraryCategory: "",
        ln: "",
        name: "InfoElementComponent"
      }
  },
  computed: {
    ...mapGetters({

      revisionHistory: 'revisionHistory',
      selectedRows: 'selectedRows',
      routingData: 'routingData'
    }),
    selectedLibrary(){
      let ln = this.ln;  
      // for (let prop in this.$store.getters.selectedRows[0]){
        
      //   if (this.$store.getters.selectedRows[0][prop].type == "library number"){
      //     ln = this.$store.getters.selectedRows[0][prop].value.display;
      //     break;
      //   }
      // }    

      return ln;
    },
    lastRevisionHistory() {

      let tab = this.$store.getters.revisionHistory;
      let obj = tab[0];
      for (let i = 0, lei = tab.length; i < lei; i++) {

        if (tab[i].revision > obj.revision) {
          obj = tab[i];
        }
      }

      return obj;
    },
    reloadedAfterActionComplex() {
      return this.$store.getters.reloadedAfterActionComplex;
    },
    // routingObject(){
    //   if (this.$store.getters.routingData.length > 0){
    //     return this.routingData[this.routingData.length - 1];
    //   }
    //   return {};
    // },
  },
  created () {
    if (this.$store.getters.selectedRows.length > 0){

      this.getDetails();
    }

  },
  watch: {
    selectedRows: function (newVal) {
      
      if (this.$store.getters.selectedRows.length > 0){

        this.getDetails();
      }
    },
    lastRevisionHistory: function () {

      this.loadDataForRevisions();

    },
    reloadedAfterActionComplex: {
      handler: function (newValue) {

        for (let el in newValue) {
          
          if (newValue[el].name == this.name) {
            if (newValue[el].status == true) {

              this.getDetails();

              newValue[el].status = false;

              this.$store.dispatch("reloadAfterActionComplex", newValue[el]);
            }
          }
        }
      },
      deep: true

    },
  },



  methods: {
    loadDataForRevisions() {

      let vue = this;

      let obj = {
        revisionId: this.$route.query.revisionId,//this.$route.query.revisionId,
        revision: 0
        
      }

      let action = "";
      let type = "";
      if (this.$store.getters.sectionPrefix == "pm"){
        action = "_getPart";
        type = "part number";
      }
      if (this.$store.getters.sectionPrefix == "lm"){
        action = "_getLibrary";
        type = "library number";
      }
      if (this.$store.getters.sectionPrefix == "projm"){
        action = "_getProject";
        type = "project number";
      }

      this.$store.dispatch(this.$store.getters.sectionPrefix + action, obj)
        .then(function (result) {
          console.log(result)

          if (result.status == "OK") {
            if (result.data != null) {
              for (let i = 0, lei = result.data.length; i < lei; i++) {
                if (result.data[i].type == type) {
                  vue.ln = result.data[i].value.display;
                }
              }
            }
          } else {

          }



        })



    },
    getDetails() {
      
      let vue = this;
      // if (this.routingObject == undefined) {
      //   return;
      // }

      let value = this.$route.query.id;//this.$store.getters.selectedRows[0].col___revisionId.libraryId;

      //this.$store.dispatch(this.$store.getters.sectionPrefix + '_getRevisionHistory', value);

      let obj = {
        revisionId: this.$route.query.revisionId//this.$store.getters.selectedRows[0].col___revisionId.revisionId
      }
      
      this.$store.dispatch(this.$store.getters.sectionPrefix + '_getCategoryByRevisionId', obj)
        .then((result) => {

          console.log(result)

          if (result.status == "OK") {

            let pos = result.data[0].categoryPath.indexOf("\\");

            let len = result.data[0].categoryPath.length;
            let str = result.data[0].categoryPath.substr(pos + 1, len);

            vue.libraryCategory = str;

          }

        })
    },


  }
}
</script>


<style scoped>


</style>


// WEBPACK FOOTER //
// src/components/shared/InfoElementComponent.vue